import { SlideAction, SlideLayout, ViewMode } from '@gripp/shared-ui';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AssetRouteProvider } from '../assetRouteContext';
import { AddButton } from '../../shared/components/addButton/addButton';
import { AssetRoutineRearrangeColumn } from './asset-routines-rearrange-column';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetRoutinesRearrange = () => {
  const { assetId, issueId } = useParams();
  const navigate = useNavigate();
  const [requestRoutineVisible, setRequestRoutineVisible] = useState(false);

  if (!assetId) {
    return null;
  }

  const leftColumn = {
    title: 'assets.menu.title',
    mainComponent: (
      <AssetRouteProvider value={{
        basePath: issueId ? `/activities/${issueId}/asset/${assetId}` : `/assets/${assetId}`,
        listPath: issueId ? '/activities' : '/assets',
        isWorkspaceMode: false,
        issueId,
      }}>
        <AssetCard assetId={assetId} />
      </AssetRouteProvider>
    ),
    headerComponent: <AssetFilters assetId={assetId} />,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => navigate(issueId ? '/activities' : '/assets'),
    disableScroll: true,
  };

  const rightColumn = {
    title: 'topNav.edit',
    mainComponent: (
      <AssetRoutineRearrangeColumn
        assetId={assetId}
        requestRoutineVisible={requestRoutineVisible}
        onRequestRoutineClose={() => setRequestRoutineVisible(false)}
      />
    ),
    headerComponent: (
      <AddButton onPress={() => setRequestRoutineVisible(true)} />
    ),
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    onBackButtonPress: () => {
      navigate('../..', { relative: 'path' });
    },
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
